import { useState } from 'react';
import Button from '../components/button/v2/button';
import ChannelInfoCard from '../components/cards/v2/channel-info.card';
import ChannelsContainer from '../components/containers/channels/channels.container';
import Container from '../components/containers/container';
import Header from '../components/header/default.header';
import InfoLayout from '../components/layouts/info.layout';
import MainLayout from '../components/layouts/v2/main.layout';
import AlternativeNavigation from '../components/navigation/alternative.navigation';
import HTab from '../components/navigation/tabs/htab';
import { CHANNELS_TAB_OPTIONS } from '../components/navigation/tabs/tab-options';
import { useInfoControl } from '../hooks/useInfoControl';
import { useModal } from '../hooks/useModal';

export default function Channels() {
  const [currentTab, setCurrentTab] = useState(CHANNELS_TAB_OPTIONS.JOINED);
  const [showInfo, current, trigger, reset] = useInfoControl<{ id: string }>();
  const [openCreateChannelOverlay] = useModal('CREATE_CHANNEL');

  const CONTENT_COMPONENT_MAP = {
    [CHANNELS_TAB_OPTIONS.JOINED]: () => (
      <ChannelsContainer trigger={trigger} query={['JOINED']} />
    ),
    [CHANNELS_TAB_OPTIONS.TRENDING]: () => (
      <ChannelsContainer trigger={trigger} query={['TRENDING']} />
    ),
    [CHANNELS_TAB_OPTIONS.RECOMMENDED]: () => (
      <ChannelsContainer trigger={trigger} query={['RECOMMENDED']} />
    ),
  };

  return (
    <MainLayout title="Channels" layout="alt">
      <MainLayout.Header>
        <Header />
      </MainLayout.Header>
      <MainLayout.Content>
        <MainLayout.Navigation>
          <AlternativeNavigation />
        </MainLayout.Navigation>
        <MainLayout.Main>
          <InfoLayout close={reset} showInfo={showInfo}>
            <InfoLayout.Content>
              <LiveArtists />
              <HTab
                current={currentTab}
                set={setCurrentTab}
                tabOptions={CHANNELS_TAB_OPTIONS}
                tabContent={CONTENT_COMPONENT_MAP}
                tabControlClassName="mobile:py-4 tablet-lg:py-4 mobile:px-2 tablet-lg:px-[40px] border-y border-dark-gray"
              />
              <Container extensions="fixed mobile:bottom-[5rem] mobile:right-2 tablet-lg:bottom-[3rem] tablet-lg:right-[2rem] z-50 bg-secondary p-2 rounded-full">
                <Button
                  onClick={openCreateChannelOverlay}
                  asIcon="add"
                  color="secondary"
                  size="lg"
                />
              </Container>
            </InfoLayout.Content>
            <InfoLayout.Aside>
              {current && (
                <ChannelInfoCard channelId={current.id} close={reset} />
              )}
            </InfoLayout.Aside>
          </InfoLayout>
        </MainLayout.Main>
      </MainLayout.Content>
    </MainLayout>
  );
}

function LiveArtists() {
  return (
    <div className="mobile:px-2 py-4 tablet-lg:px-[40px] ">Subscriptions</div>
  );
}
